import { useNavigate } from 'react-router';

import { t } from 'translations/src/LocaleContext';
import { Header, HorizontalLine } from 'ui';
import { MainContainer } from 'ui/styles/containers';
import { Link, MediumTitle, PageSubtitle, PageTitle } from 'ui/styles/text';

import { routes } from '../../routes';
import { ErrorMessages } from './ErrorMessages';
import { ExportsList } from './ExportsList';
import { InitiateButton } from './InitiateButton';

const title = t('membership_hub_data_export_title');
const subTitle = t('membership_hub_data_export_description', {
  PrivacyPolicyLink: (linkText) => (
    <Link href="https://ouraring.com/privacy-policy" target="_blank" $fontSize="inherit" $decoration="underline">
      {linkText}
    </Link>
  ),
});
const listLabel = t('membership_hub_data_export_list_title');

export const MemberDataExportPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header appType="hub" onBackClick={() => navigate(routes.index)} />

      <MainContainer $maxWidth="794px" $alignItems="normal">
        <ErrorMessages />

        <PageTitle>{title}</PageTitle>
        <PageSubtitle data-testid="pageSubtitle">{subTitle}</PageSubtitle>

        <InitiateButton />

        <HorizontalLine $margin="2rem 0" />

        <MediumTitle $margin="0 0 1rem" $fontSize="medium">
          {listLabel}
        </MediumTitle>
        <ExportsList />
      </MainContainer>
    </>
  );
};
